import {FormatMessageFunction} from '../../../../types';

function getNestedAddressMessage(field: string, formatMessage: FormatMessageFunction): string | undefined {
  if (field.match('.post_code')) {
    return formatMessage({id: 'phoenix.errors.address.postCode.empty'});
  }
  if (field.match('.post_town')) {
    return formatMessage({id: 'phoenix.errors.address.postTown.empty'});
  }
  if (field.match('.country')) {
    return formatMessage({id: 'phoenix.errors.address.country.empty'});
  }
  if (field.match('.building_number_and_street_name')) {
    return formatMessage({id: 'phoenix.errors.address.buildingNumberAndStreetName.empty'});
  }
  return undefined;
}

function getNestedDirectorMessage(field: string, formatMessage: FormatMessageFunction): string | undefined {
  if (field.match('.first_name')) {
    return formatMessage({id: 'phoenix.errors.firstName.empty'});
  }
  if (field.match('.surname')) {
    return formatMessage({id: 'phoenix.errors.surname.empty'});
  }
  if (field.match('.date_of_birth')) {
    return formatMessage({id: 'phoenix.errors.dateOfBirth.empty'});
  }
  if (field.match('.email')) {
    return formatMessage({id: 'phoenix.errors.email.empty'});
  }
  if (field.match('.telephone')) {
    return formatMessage({id: 'phoenix.errors.telephone.empty'});
  }
  if (field.match('.property_value')) {
    return formatMessage({id: 'phoenix.errors.propertyValue.empty'});
  }
  return undefined;
}

function getRequiredErrorMessageFromName(field: string, formatMessage: FormatMessageFunction): string {
  // check for nested address fields
  const nestedAddressRequiredMessage = getNestedAddressMessage(field, formatMessage);
  if (nestedAddressRequiredMessage) {
    return nestedAddressRequiredMessage;
  }

  const nestedDirectorRequiredMessage = getNestedDirectorMessage(field, formatMessage);
  if (nestedDirectorRequiredMessage) {
    return nestedDirectorRequiredMessage;
  }

  switch (field) {
    case 'requested_amount':
      return formatMessage({id: 'apply.errors.requestedAmount.empty'});
    case 'email':
    case 'emailAddress':
      return formatMessage({id: 'phoenix.errors.email.empty'});
    case 'when_finance_required':
      return formatMessage({id: 'apply.errors.whenFinanceRequired.empty'});
    case 'finance_purpose':
      return formatMessage({id: 'apply.errors.financePurpose.empty'});
    case 'capital_type':
      return formatMessage({id: 'apply.errors.capitalType.empty'});
    case 'registered':
      return formatMessage({id: 'apply.errors.registered.empty'});
    case 'businessName':
    case 'business_name':
      return formatMessage({id: 'phoenix.errors.businessName.empty'});
    case 'revenue':
      return formatMessage({id: 'apply.errors.revenue.empty'});
    case 'trading_startdate':
    case 'registration_date':
      return formatMessage({id: 'apply.errors.tradingStartDate.empty'});
    case 'legal_status':
      return formatMessage({id: 'apply.errors.legalStatus.empty'});
    case 'first_name':
    case 'firstName':
      return formatMessage({id: 'phoenix.errors.firstName.empty'});
    case 'surname':
    case 'last_name':
      return formatMessage({id: 'phoenix.errors.surname.empty'});
    case 'telephone':
      return formatMessage({id: 'phoenix.errors.telephone.empty'});
    case 'mobilePhone':
      return formatMessage({id: 'phoenix.errors.mobilePhone.empty'});
    case 'asset_finance_type':
      return formatMessage({id: 'apply.errors.assetFinanceType.empty'});
    case 'property_finance_type':
      return formatMessage({id: 'apply.errors.propertyFinanceType.empty'});
    case 'type_of_property':
      return formatMessage({id: 'apply.errors.typeOfProperty.empty'});
    case 'living_in_the_property':
      return formatMessage({id: 'apply.errors.livingInTheProperty.empty'});
    case 'property_development_type':
      return formatMessage({id: 'apply.errors.propertyDevelopmentType.empty'});
    case 'type_of_mortgage':
      return formatMessage({id: 'apply.errors.typeOfMortgage.empty'});
    case 'owns_property':
      return formatMessage({id: 'apply.errors.ownsProperty.empty'});
    case 'trade_with_restricted_countries':
      return formatMessage({id: 'apply.errors.tradeWithRestrictedCountries.empty'});
    case 'company_number':
      return formatMessage({id: 'apply.errors.companyNumber.empty'});
    case 'business_summary':
      return formatMessage({id: 'apply.errors.businessSummary.empty'});
    case 'confirmationCode':
      return formatMessage({id: 'phoenix.errors.confirmationCode.empty'});
    case 'password':
    case 'oldPassword':
    case 'newPassword':
      return formatMessage({id: 'phoenix.errors.password.empty'});
    case 'terms_and_conditions':
      return formatMessage({id: 'phoenix.errors.termsAndConditions.empty'});
    case 'finance_duration':
      return formatMessage({id: 'phoenix.errors.financeDuration.empty'});
    case 'how_soon_finance_required':
      return formatMessage({id: 'phoenix.errors.howSoonFinanceRequired.empty'});
    case 'other_finance_purpose':
      return formatMessage({id: 'phoenix.errors.otherFinancePurpose.empty'});
    case 'industry':
      return formatMessage({id: 'phoenix.errors.industry.empty'});
    case 'last_12_months_profit':
      return formatMessage({id: 'phoenix.errors.last12MonthsProfit.empty'});
    case 'card_revenue':
      return formatMessage({id: 'phoenix.errors.cardRevenue.empty'});
    case 'monthly_expense_amount':
      return formatMessage({id: 'phoenix.errors.monthlyExpenseAmount.empty'});
    case 'monthly_non_business_income':
      return formatMessage({id: 'phoenix.errors.monthlyNonBusinessIncome.empty'});
    case 'monthly_other_household_income':
      return formatMessage({id: 'phoenix.errors.monthlyOtherHouseholdIncome.empty'});
    case 'monthly_turnover':
      return formatMessage({id: 'phoenix.errors.monthlyTurnover.empty'});
    case 'number_of_dependents':
      return formatMessage({id: 'phoenix.errors.numberOfDependents.empty'});
    case 'residential_status':
      return formatMessage({id: 'phoenix.errors.residentialStatus.empty'});
    case 'role':
      return formatMessage({id: 'phoenix.errors.role.empty'});
    case 'date_of_birth':
      return formatMessage({id: 'phoenix.errors.dateOfBirth.empty'});
    case 'outstanding_invoices':
      return formatMessage({id: 'phoenix.errors.outstandingInvoices.empty'});
    default:
      return formatMessage({id: 'apply.errors.generic.empty'});
  }
}

export default getRequiredErrorMessageFromName;
